module.exports = __webpack_public_path__ + "static/elephant-3-551781ded93c39ede3a2e2a81bae378f.png";